"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcMeterGeneralPanel = class UcMeterGeneralPanel extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    meter;
    onMeter(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("meter");
    }
    ux;
    dataMembers = ['ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                ux: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_emit_9402_getActionArgs($event) {
        return {
            event: "saved",
            value: $event.data.modalResult.value,
        };
    }
    async evh_8320016629450276_close_9401_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_8320016629450276_showModal_9400_getActionArgs($event) {
        return {
            name: "MeterEditor",
            props: {
                meter: this.meter.editor(),
            },
        };
    }
    async evh_8320016629450276_clickPreventStop(event, scope) {
        return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async act_3818132362335583_emit_9404_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_3818132362335583_reload(event, scope) {
        return await this.actions.evh_3818132362335583_reload.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_9398 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_9397 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_9398,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_9397],
        });
        const act_8320016629450276_emit_9402 = new core_1.actions.EmitAction({
            actionArgs: this.act_8320016629450276_emit_9402_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_close_9401 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_emit_9402,
            event: "close",
            when: this.evh_8320016629450276_close_9401_getWhen,
            displayName: "emit",
        });
        const act_8320016629450276_showModal_9400 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_9400_getActionArgs,
            events: [evh_8320016629450276_close_9401],
        });
        const evh_8320016629450276_clickPreventStop_9399 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_9400,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_8320016629450276_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_clickPreventStop_9399],
        });
        const act_3818132362335583_emit_9404 = new core_1.actions.EmitAction({
            actionArgs: this.act_3818132362335583_emit_9404_getActionArgs,
            displayName: "emitReload",
            events: [],
        });
        const evh_3818132362335583_reload_9403 = new core_1.actions.EventHandlerImpl({
            action: act_3818132362335583_emit_9404,
            event: "reload",
            displayName: "emitReload",
        });
        const evh_3818132362335583_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3818132362335583_reload_9403],
        });
        return {
            act_7315092382398562_reloadComponentData_9398,
            evh_7315092382398562_reload_9397,
            evh_7315092382398562_reload,
            act_8320016629450276_emit_9402,
            evh_8320016629450276_close_9401,
            act_8320016629450276_showModal_9400,
            evh_8320016629450276_clickPreventStop_9399,
            evh_8320016629450276_clickPreventStop,
            act_3818132362335583_emit_9404,
            evh_3818132362335583_reload_9403,
            evh_3818132362335583_reload,
            emitReload: act_3818132362335583_emit_9404,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcMeterGeneralPanel.prototype, "meter", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('meter'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcMeterGeneralPanel.prototype, "onMeter", null);
UcMeterGeneralPanel = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcMeterGeneralPanel);
exports.default = UcMeterGeneralPanel;
vue_property_decorator_1.Vue.component("UcMeterGeneralPanel", UcMeterGeneralPanel);
